import { render } from "./Guests.vue?vue&type=template&id=5ddd3520&scoped=true&ts=true"
import script from "./Guests.vue?vue&type=script&lang=ts"
export * from "./Guests.vue?vue&type=script&lang=ts"

import "./Guests.vue?vue&type=style&index=0&id=5ddd3520&scoped=true&lang=css"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddd3520"]])

export default __exports__